import React from "react";
import { useScreenDetector } from "../../hooks/useScreenDetector";

export default function Modal(props) {
  const { isMobile } = useScreenDetector();

  return (
    <React.Fragment>
      {props.isShow && (
        <div className="fixed w-full h-full z-[99999] top-0 left-0 backdrop-blur-sm bg-black/30">
          <div className="absolute flex flex-col bg-white rounded-2xl w-[90%] sm:w-auto left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2">
            <div className="border-b w-full h-16 border-gray-200 relative flex items-center pl-8 pr-4">
              <div className="flex-1">{props.data.modalTitle}</div>
              <div
                className="w-8 h-8 rounded-full bg-gray-200 text-gray-500 text-xl flex justify-center items-center cursor-pointer hover:border hover:border-gray-400"
                onClick={() => props.setShowModal(false)}
              >
                <img
                  src="https://srv-cdn.onedio.com/store/95d1c4c0cabeff86afdccb873630f46e4ceb2b97253b0374d3759fbb442210a1.png"
                  className="w-3 h-3"
                />
              </div>
            </div>
            <div>
              {props.data.modal === "image" ? (
                <img src={props.data.image} className="p-4" />
              ) : props.data.modal === "video" ? (
                <video
                  className="video-iframe"
                  playsInline
                  muted
                  autoPlay
                  controls
                >
                  <source src={props.data.video} type="video/mp4" />
                  Your browser does not support HTML5 video.
                </video>
              ) : (
                <iframe
                  src={props.data.url}
                  className="video-iframe"
                  style={{
                    width: isMobile ? "100%" : props.data.width,
                    height: props.data.height,
                  }}
                ></iframe>
              )}
            </div>
          </div>
        </div>
      )}
    </React.Fragment>
  );
}
